import { flattenDeep } from 'lodash';

import * as accounts from './resources/accounts';
import * as accountTeamMembers from './resources/accountTeamMembers';
import * as alternativeAssets from './resources/alternativeAssets';
import * as apiClients from './resources/apiClients';
import * as articles from './resources/articles';
import * as authenticatorDevices from './resources/authenticatorDevices';
import * as cashFlowEvents from './resources/cashFlowEvents';
import * as clients from './resources/clients';
import * as costReports from './resources/costReports';
import * as configuration from './resources/configuration';
import * as documents from './resources/documents';
import * as events from './resources/events';
import * as expertInputDocuments from './resources/expertInputDocuments';
import * as expertInput from './resources/expertInput';
import * as family from './resources/family';
import * as feed from './resources/feed';
import * as filterValues from './resources/filterValues';
import * as financialValues from './resources/financialValues';
import * as forms from './resources/forms';
import * as funds from './resources/funds';
import * as goals from './resources/goals';
import * as illiquidCashflow from './resources/illiquidCashflow';
import * as illiquidSecurities from './resources/illiquidSecurities';
import * as investmentProfile from './resources/investmentProfile';
import * as investmentStrategies from './resources/investmentStrategies';
import * as investmentStrategyAssetAllocations from './resources/investmentStrategyAssetAllocations';
import * as investmentStrategyImplementationPlans from './resources/investmentStrategyImplementationPlans';
import * as investmentStrategyIndexChanges from './resources/investmentStrategyIndexChanges';
import * as investmentStrategyPortfolioCharacteristics from './resources/investmentStrategyPortfolioCharacteristics';
import * as investmentStrategyProducts from './resources/investmentStrategyProducts';
import * as investmentStrategyPreferences from './resources/investmentStrategyPreferences';
import * as investmentStrategyCosts from './resources/investmentStrategyCosts';
import * as investmentStrategySimulations from './resources/investmentStrategySimulations';
import * as marketValues from './resources/marketValues';
import * as meetings from './resources/meetings';
import * as milestones from './resources/milestones';
import * as network from './resources/network';
import * as offices from './resources/offices';
import * as operationalMessages from './resources/operationalMessages';
import * as organization from './resources/organization';
import * as personalGreeting from './resources/personalGreeting';
import * as podcastEpisodes from './resources/podcastEpisodes';
import * as portfolioIndices from './resources/portfolioIndices';
import * as periodicIndices from './resources/periodicIndices';
import * as investmentStrategyDocuments from './resources/investmentStrategyDocuments';
import * as portfolioCashflow from './resources/portfolioCashflow';
import * as portfolioLenses from './resources/portfolioLenses';
import * as portfolios from './resources/portfolios';
import * as securities from './resources/securities';
import * as securityPerformance from './resources/securityPerformance';
import * as signingEvents from './resources/signingEvents';
import * as standardFilters from './resources/standardFilters';
import * as strategy from './resources/strategy';
import * as tasks from './resources/tasks';
import * as taxDetails from './resources/taxDetails';
import * as transactions from './resources/transactions';
import * as users from './resources/users';
import * as wealthBalance from './resources/wealthBalance';
import * as webinars from './resources/webinars';
import * as assetClassBenchmarkIndices from './resources/assetClassBenchmarkIndices';

export const sagas = flattenDeep([
  ...accounts.sagas,
  ...accountTeamMembers.sagas,
  ...alternativeAssets.sagas,
  ...apiClients.sagas,
  ...articles.sagas,
  ...authenticatorDevices.sagas,
  ...cashFlowEvents.sagas,
  ...clients.sagas,
  ...costReports.sagas,
  ...configuration.sagas,
  ...documents.sagas,
  ...events.sagas,
  ...expertInputDocuments.sagas,
  ...expertInput.sagas,
  ...family.sagas,
  ...feed.sagas,
  ...filterValues.sagas,
  ...financialValues.sagas,
  ...forms.sagas,
  ...funds.sagas,
  ...goals.sagas,
  ...illiquidCashflow.sagas,
  ...illiquidSecurities.sagas,
  ...investmentProfile.sagas,
  ...investmentStrategies.sagas,
  ...investmentStrategyAssetAllocations.sagas,
  ...investmentStrategyImplementationPlans.sagas,
  ...investmentStrategyIndexChanges.sagas,
  ...investmentStrategyPortfolioCharacteristics.sagas,
  ...investmentStrategyProducts.sagas,
  ...investmentStrategyPreferences.sagas,
  ...investmentStrategyCosts.sagas,
  ...investmentStrategySimulations.sagas,
  ...marketValues.sagas,
  ...meetings.sagas,
  ...milestones.sagas,
  ...network.sagas,
  ...offices.sagas,
  ...operationalMessages.sagas,
  ...organization.sagas,
  ...personalGreeting.sagas,
  ...podcastEpisodes.sagas,
  ...portfolioIndices.sagas,
  ...periodicIndices.sagas,
  ...investmentStrategyDocuments.sagas,
  ...portfolioCashflow.sagas,
  ...portfolioLenses.sagas,
  ...portfolios.sagas,
  ...securities.sagas,
  ...securityPerformance.sagas,
  ...signingEvents.sagas,
  ...standardFilters.sagas,
  ...strategy.sagas,
  ...tasks.sagas,
  ...taxDetails.sagas,
  ...transactions.sagas,
  ...users.sagas,
  ...wealthBalance.sagas,
  ...webinars.sagas,
  ...assetClassBenchmarkIndices.sagas,
]);
